import React from 'react';
import styled from 'styled-components';
import {
  useFormikContext,
  ErrorMessage,
  FormikValues,
  FormikErrors,
  FormikTouched,
} from 'formik';
import { IInputError } from './types';

import theme from '../../../../styles/userflow';

interface FormikContext {
  errors: FormikErrors<FormikValues>;
  touched: FormikTouched<FormikValues>;
  values: FormikValues;
}
const InputError: React.FC<IInputError> = ({
  className,
  name,
  renderAppendAddon,
}) => {
  const { errors, touched, values } = useFormikContext<FormikContext>();

  const hasError = errors[name] && touched[name];

  if (!hasError) {
    return null;
  }

  return (
    <StyledInputError className={className}>
      <ErrorMessage name={name} />
      {renderAppendAddon && renderAppendAddon(values[name])}
    </StyledInputError>
  );
};

const StyledInputError = styled.div`
  margin-top: 4px;
  color: ${theme.colors.monza};
  max-width: fit-content;
`;

export default InputError;
